"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createApi = require("../../createApi");

var InteractionsApi = function (_BaseApi) {
  (0, _inherits2["default"])(InteractionsApi, _BaseApi);

  function InteractionsApi() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, InteractionsApi);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(InteractionsApi)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadImage", function (payload) {
      return _this.api.post('/upload', {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteImage", function (_ref) {
      var userId = _ref.userId,
          clientId = _ref.clientId,
          imagePath = _ref.imagePath;
      return _this.api["delete"]('/image', {
        params: {
          userId: userId,
          clientId: clientId,
          imagePath: imagePath
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createActivity", function (_ref2) {
      var activity = _ref2.activity,
          feedOptions = _ref2.feedOptions;
      return _this.api.post('/activity', {
        data: {
          activity: activity,
          feedOptions: feedOptions
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteActivity", function (_ref3) {
      var activityId = _ref3.activityId,
          feedId = _ref3.feedId,
          userId = _ref3.userId,
          targetId = _ref3.targetId;
      return _this.api["delete"]("/activity/".concat(activityId), {
        params: {
          feedId: feedId,
          userId: userId,
          targetId: targetId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createReaction", function (_ref4) {
      var reaction = _ref4.reaction,
          feedOptions = _ref4.feedOptions;
      return _this.api.post('/reaction', {
        data: {
          reaction: reaction,
          feedOptions: feedOptions
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteReaction", function (_ref5) {
      var reactionId = _ref5.reactionId,
          activityId = _ref5.activityId;
      return _this.api["delete"]("/reaction/".concat(reactionId), {
        params: {
          activityId: activityId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createMessage", function (_ref6) {
      var clientId = _ref6.clientId,
          content = _ref6.content,
          medias = _ref6.medias,
          groupId = _ref6.groupId;
      return _this.api.post('/messages', {
        data: {
          clientId: clientId,
          content: content,
          medias: medias,
          groupId: groupId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createComment", function (_ref7) {
      var clientId = _ref7.clientId,
          content = _ref7.content,
          feedItemId = _ref7.feedItemId,
          feedType = _ref7.feedType,
          medias = _ref7.medias;
      return _this.api.post('/comments', {
        data: {
          clientId: clientId,
          content: content,
          feedItemId: feedItemId,
          feedType: feedType,
          medias: medias
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getComments", function (_ref8) {
      var clientId = _ref8.clientId,
          feedItemId = _ref8.feedItemId,
          feedType = _ref8.feedType,
          limit = _ref8.limit,
          next = _ref8.next;
      return _this.api.get("/comments/", {
        params: {
          clientId: clientId,
          feedItemId: feedItemId,
          feedType: feedType,
          limit: limit,
          next: next
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "uploadMedia", function (payload) {
      return _this.api.post('/medias', {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: payload
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteOneComment", function (_ref9) {
      var feedType = _ref9.feedType,
          commentId = _ref9.commentId,
          clientId = _ref9.clientId;
      return _this.api["delete"]("/comments/".concat(commentId), {
        params: {
          feedType: feedType,
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteOneMessage", function (_ref10) {
      var messageId = _ref10.messageId,
          clientId = _ref10.clientId;
      return _this.api["delete"]("/messages/".concat(messageId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createItemReaction", function (_ref11) {
      var feedType = _ref11.feedType,
          feedItemId = _ref11.feedItemId,
          emoji = _ref11.emoji,
          clientId = _ref11.clientId,
          commentId = _ref11.commentId;
      return _this.api.post('/reactions', {
        data: {
          feedType: feedType,
          feedItemId: feedItemId,
          emoji: emoji,
          clientId: clientId,
          commentId: commentId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteItemReaction", function (_ref12) {
      var feedType = _ref12.feedType,
          feedItemId = _ref12.feedItemId,
          emoji = _ref12.emoji,
          clientId = _ref12.clientId,
          commentId = _ref12.commentId;
      return _this.api["delete"]("/reactions", {
        params: {
          feedType: feedType,
          feedItemId: feedItemId,
          emoji: emoji,
          clientId: clientId,
          commentId: commentId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getReactionsCount", function (_ref13) {
      var clientId = _ref13.clientId,
          type = _ref13.type,
          id = _ref13.id;
      return _this.api.get("/reactions/".concat(type, "/").concat(id, "/count"), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "createActivityShare", function (_ref14) {
      var clientId = _ref14.clientId,
          content = _ref14.content,
          medias = _ref14.medias,
          groupId = _ref14.groupId,
          activityId = _ref14.activityId;
      return _this.api.post('/activity-share', {
        data: {
          clientId: clientId,
          content: content,
          medias: medias,
          groupId: groupId,
          activityId: activityId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteActivityShare", function (_ref15) {
      var activityShareId = _ref15.activityShareId,
          clientId = _ref15.clientId;
      return _this.api["delete"]("/activity-share/".concat(activityShareId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getActivityShareByActivity", function (_ref16) {
      var activityId = _ref16.activityId,
          clientId = _ref16.clientId;
      return _this.api.get("/activity-share/activity/".concat(activityId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reportMessage", function (props) {
      return _this.api.post('/report', {
        data: 'commentGroupId' in props ? {
          clientId: props.clientId,
          commentGroupId: props.commentGroupId
        } : {
          clientId: props.clientId,
          feedType: props.feedType,
          feedItemId: props.feedItemId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getModerationItems", function (_ref17) {
      var clientId = _ref17.clientId,
          status = _ref17.status,
          topParentId = _ref17.topParentId,
          groupId = _ref17.groupId,
          reportedAfter = _ref17.reportedAfter,
          skip = _ref17.skip,
          limit = _ref17.limit;
      return _this.api.get('/moderation', {
        params: {
          clientId: clientId,
          status: status,
          topParentId: topParentId,
          groupId: groupId,
          reportedAfter: reportedAfter,
          skip: skip,
          limit: limit
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getModerationItemWithDetails", function (clientId, moderationItemId) {
      return _this.api.get("/moderation/".concat(moderationItemId), {
        params: {
          clientId: clientId
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "approveReportedMessages", function (clientId, moderationItems) {
      return _this.api.put('/moderation/approve', {
        data: {
          clientId: clientId,
          moderationItems: moderationItems
        }
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "deleteReportedMessages", function (clientId, moderationItems) {
      return _this.api.put('/moderation/delete', {
        data: {
          clientId: clientId,
          moderationItems: moderationItems
        }
      });
    });
    return _this;
  }

  return InteractionsApi;
}(_createApi.BaseApi);

var _default = InteractionsApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map